
import { defineComponent, onMounted } from 'vue';
import { AppTable, AppCard, AppButton } from '@/components';
import { useLeagueTierList } from '@/modules/league/tier/model/list';
import { TableColumnType, TableConfig } from '@/components/table/types';
import { ROUTE_NAME_LEAGUE } from '@/modules/league/router';

export default defineComponent({
    name: ROUTE_NAME_LEAGUE.TIER.INDEX,
    components: { AppTable, AppCard, AppButton },
    setup() {
        const { list, total, canAddNew, fetchList, actions, itemId } = useLeagueTierList();

        const table: TableConfig = {
            columns: [
                { type: TableColumnType.Text, label: 'Tier', key: 'tier' },
                { type: TableColumnType.Text, label: 'Name', key: 'name' },
                { type: TableColumnType.Text, label: 'Point', key: 'point' },
                { type: TableColumnType.Image, label: 'Image', imageKey: 'image', statusKey: 'imageStatus' },
                { type: TableColumnType.Actions, label: 'Actions' }
            ],
            actions: [
                {
                    props: (row: any) => ({
                        icon: 'fa-award',
                        theme: 'info',
                        tooltip: 'Show reward',
                        to: { name: ROUTE_NAME_LEAGUE.TIER.REWARD.INDEX, params: { itemId, tier: row.tier } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-edit',
                        theme: 'info',
                        tooltip: 'Edit',
                        to: { name: ROUTE_NAME_LEAGUE.TIER.EDIT, params: { itemId, tier: row.tier } }
                    }),
                    canShow: (row: any) => row.canEdit,
                    group: 1
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-trash-alt',
                        theme: 'danger',
                        tooltip: 'Delete',
                        disabled: !row.canDelete,
                        onClick: () => actions.remove(row.tier)
                    })
                }
            ]
        };

        onMounted(fetchList);

        return { table, canAddNew, list, total, fetchList, itemId, ROUTE_NAME_LEAGUE };
    }
});
